<template>
  <el-container style="height: 100%" class="pagefra">
    <pagesider v-if="!$store.state.pageScroll.scroll && !$store.state.siderConfig.isHide"></pagesider>
    <el-container style="height: 100%" class="pagefra-main">
      <!-- <el-header height="112px" class="header">
        <div class="header__title">
          <h2>
            {{ $route.matched[0].meta.title }}
            <span v-if="$route.matched[0].redirect"
              >｜{{ $route.meta.title }}</span
            >
          </h2>
          <p>{{ $route.matched[0].meta.info }}</p>
        </div>
        <el-row type="flex" class="header__avatar">
          <el-col>
            <h4>{{ user.username }}</h4>
            <p>{{ user.roleName }}</p>
          </el-col>
          <el-avatar :src="avatarUrl" fit="cover"></el-avatar>
        </el-row>
      </el-header>-->
      <pageheader></pageheader>
      <page-tabs></page-tabs>

      <!-- <el-container> -->
      <el-main>
        <slot></slot>
      </el-main>
      <!-- </el-container> -->
    </el-container>
    <!-- <audio :src="url" loop id="alarm2" hidden></audio> -->
  </el-container>
</template>

<script>
// @ is an alias to /src
import pagesider from "@/components/pagesider.vue";
import pageheader from "@/components/pageheader.vue";
import "@/icons";
import global from "@/mixins/global.js";
import PageTabs from "@/components/pageTabs.vue";
// import logoUrl from "@/assets/img/logo_w.png";
// import avatarUrl from "@/assets/img/user_head.png";

export default {
  name: "pagefra",
  mixins: [global],
  components: {
    pagesider,
    pageheader,
    PageTabs,
  },
  data() {
    return {
      siderWidth: "300px",
      isMenuCollapse: false,
      isReloadAlive: true,
      user: null,
      isSelectedMenu: {
        name: "",
        index: "",
      },
      avatarUrl: require("@/assets/img/user_head.png"),
      interval: "",
      url: require("@/assets/media/alarm.mp3"),
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  mounted() {},
  created() {
    const userJson = localStorage.getItem("user");
    const permissionJson = localStorage.getItem("permissions");
    if (!userJson) {
      this.$router.push({
        path: "login",
      });
    }
    this.$store.state.user = JSON.parse(userJson);
    if (this.$store.state.user.roleType != 1 && (!permissionJson || JSON.parse(permissionJson).length == 0)) {
      this.$router.push({
        path: "login",
      });
    }
    this.$store.state.permissions = JSON.parse(permissionJson);
    const indexJson = localStorage.getItem("indexPermissions");
    if (indexJson) {
      this.$store.state.indexPermissions = JSON.parse(indexJson);
    }
    const fieldJson = localStorage.getItem("fieldPermissions");
    if (fieldJson) {
      this.$store.state.fieldPermissions = JSON.parse(fieldJson);
    }
    this.initAlarm();
  },
  computed: {},
  watch: {},
  methods: {
    initAlarm() {
      if (!this.$store.state.alarmAudio) {
        this.$store.state.alarmAudio = document.getElementById("alarm");
        if (this.$store.state.alarmAudio) {
          window.removeEventListener("mousedown", this.initAlarm, false);
        } else {
          window.addEventListener("mousedown", this.initAlarm, false);
        }
        this.alarmTips();
      } else {
        this.alarmTips();
      }
    },
    onSubmit() {},
    reload() {
      this.isReloadAlive = false;
      this.$nextTick(function() {
        this.isReloadAlive = true;
      });
    },
  },
};
</script>
<style lang="scss">
.pagefra {
  position: absolute;
  width: 100%;
  height: 100%;
  &-main {
    flex-direction: column;
  }
}
.el-container {
  width: 100%;
  min-height: 0;
  flex: 1;
}
.header {
  position: relative;
  display: flex;
  padding-left: 0;
  // background: #fff;
  // background-size: cover;

  &__title {
    padding-top: 34px;
    flex: 1;
    // color: $--color-primary;
    padding-left: 22px;
    h2 {
      font-size: 29px;
      // font-weight: bold;
      padding-left: 0px;
      margin: 0;
      line-height: 35px;
    }
    p {
      color: #9fa0a0;
      font-size: 16px;
    }
  }
  &__avatar {
    padding-top: 40px;
    text-align: right;
    h4 {
      font-size: $--font-size-large;
    }
    p {
      color: $--color-text-secondary;
      font-size: $--font-size-small;
    }
    .el-avatar {
      min-width: 45px;
      min-height: 45px;
      margin-left: 10px;
    }
  }
  ul {
    display: flex;
    color: #6e7e95;
    li {
      margin: 0 20px;
      line-height: 60px;
      i {
        display: inline-block;
        vertical-align: middle;
        height: 18px;
        width: 18px;
        margin-right: 5px;
        background-position: center top;
        background-repeat: no-repeat;
      }
    }
  }
}

//----------------------------
//  自适应
//----------------------------
@media screen and (max-width: $--lg) {
  .sider {
    width: 250px !important;
  }
  .sider .logo .el-image .el-image__inner {
    max-width: 200px;
  }
  .el-main {
    padding: 15px;
  }
}
</style>
